// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import installPlugin from '@/plugin'
// import 'iview/dist/styles/iview.css'
import 'view-design/dist/styles/iview.css'
import './index.less'
import '@/assets/icons/iconfont.css'
import VueClipboard from 'vue-clipboard2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import SlideVerify from 'vue-monoplasty-slide-verify'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import wechatAuth from './libs/wechatAuth'
import locale from 'element-ui/lib/locale/lang/zh-CN'

// 这里是配置微信公众号的appid
// Vue.use(wechatAuth, {
//   appid: "wxdc747dd1a568d53b",
//   scope: 'snsapi_userinfo',
// })
Vue.use(ElementUI, { locale,
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(VueClipboard)
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
// Vue.use(ViewUI)
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})


Vue.use(SlideVerify);
Vue.use(VueVideoPlayer);


/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
